import { c as _c } from "react/compiler-runtime";
import { type JSX, useMemo } from 'react';
import sanitize from 'sanitize-html';
import { TrustedHtmlProps } from './types';

/**
 * Use this component for and only for inserting HTML we can trust.
 */
export const TrustedHtml = t0 => {
  const $ = _c(12);
  let props;
  let t1;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      as: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = value;
  } else {
    props = $[1];
    t1 = $[2];
    value = $[3];
  }
  const as = t1 === undefined ? "span" : t1;
  const Tag = as;
  let t2;
  if ($[4] !== value) {
    t2 = value ? sanitize(value) : "";
    $[4] = value;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const __html = t2;
  let t3;
  if ($[6] !== __html) {
    t3 = {
      __html
    };
    $[6] = __html;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== Tag || $[9] !== props || $[10] !== t3) {
    t4 = <Tag dangerouslySetInnerHTML={t3} {...props} />;
    $[8] = Tag;
    $[9] = props;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};